
module.directive('hseFollowup', function($q, FollowupService, Notifications, ModelService) {

    return {
        restrict: 'E',
        templateUrl: 'students/followup/hseFollowupDirective',
        scope: {profileId: '='},

        link: function(scope, element, attrs) {
            scope.loaded = true;
            loadData();

            function setData(data) {
                scope.loading = false;
                scope.followup = data;
            }

            function loadData() {
                scope.data = {};
                FollowupService.loadFollowup('education_profile',
                                             scope.profileId)
                    .then(setData);
            }

            scope.save = function(form, data) {
                if (form.$invalid) {
                    Notifications.canned('form_errors');
                    return; $q.reject();
                }

                if (data.action === 'add') {
                    return ModelService.patch('education_profile', scope.profileId, {
                        credential_awarded: data.credential_awarded,
                        credential_date: data.date,
                    }).then(function() {
                        Notifications.success('HSE added.')
                        loadData();
                    });
                }

                else {
                    success = data.action === 'verify';
                    return ModelService.post('verification', {
                        participant_id: scope.profileId,
                        type: 'hse',
                        successful: success,
                        date: data.date,
                    }).then(function(verification) {
                        msg = success ? "Verified" : "marked as unable to verify.";
                        Notifications.success("HSE " + msg);
                        form.$setPristine();
                        loadData();
                    });
                }
            }
        }
    };
});
